import { Box, Button, Link, Typography } from '@mui/material'

interface Props {
  accept?: string
  selectFile: (selectedFile: File | undefined) => void
  useButton?: boolean
}

export const DragAndDropFilePicker = (props: Props): JSX.Element => {
  const formatAccept = (accept: string): string => {
    const extensions = accept.split(',').map(ext => ext.trim())
    if (extensions.length <= 1) {
      return extensions[0] ?? ''
    }
    if (extensions.length === 2) return `${extensions[0]} or ${extensions[1]}`
    return `${extensions.slice(0, -1).join(', ')}, or ${extensions[extensions.length - 1]}`
  }

  const handleDropFile = (e: React.DragEvent<HTMLDivElement>): void => {
    e.preventDefault()
    e.stopPropagation()

    const selectedFile = e.dataTransfer.files?.[0]

    props.selectFile(selectedFile)
  }

  const handleFileSelect = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const selectedFile = e.target.files?.[0]

    props.selectFile(selectedFile)
  }

  const clearFile = (e: React.MouseEvent<HTMLInputElement>): void => {
    e.currentTarget.value = ''
    props.selectFile(undefined)
  }

  return (
    <Box sx={{ width: '100%', minWidth: 0, boxSizing: 'border-box' }}>
      {props.accept != null &&
        <Typography
          variant='body1'
          sx={{
            mb: 2,
            textAlign: 'left',
            width: '100%',
            whiteSpace: 'normal'
          }}
        >
          Drag the file you want to upload or choose one from your computer. File must be in {formatAccept(props.accept)}. Max file size 500mb.
        </Typography>
      }
      <Box
        data-testid='filePickerDropArea'
        onDrop={handleDropFile}
        onDragOver={(e) => { e.preventDefault() }}
        sx={{
          border: '2px dashed #908D91',
          borderRadius: '0',
          bgcolor: '#FAFAFA',
          p: { xs: 2, md: 4 },
          width: '70%',
          boxSizing: 'border-box',
          textTransform: 'none',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'default',
          color: 'black'
        }}
      >
        <Typography variant='body1' sx={{ textAlign: 'center', overflowWrap: 'break-word' }}>
          Drag and drop your file here
        </Typography>

        <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: props.useButton === true ? 'column' : 'row', flexWrap: 'wrap', justifyContent: 'center' }}>
          <Typography variant='body1' sx={{ textAlign: 'center' }}>
            or
          </Typography>

          { props.useButton === true
            ? <Button
                component='label'
                sx={{
                  background: 'linear-gradient(96.34deg, var(--blue-900) 0%, var(--blue-500) 100%)',
                  '&:hover': {
                    background: 'linear-gradient(96.34deg, #01142b 0%, var(--blue-700) 100%)'
                  },
                  mt: 1
                }}
                variant='contained'
                data-testid='filePickerButton'
            >
              <Typography variant='body1' sx={{ color: 'white', textAlign: 'center' }}>Add your file</Typography>
              <input hidden type='file' name='file' accept={props.accept} onChange={handleFileSelect} onClick={clearFile} data-testid='filePickerInput' />
            </Button>
            : <Link component='label' sx={{ ml: '.25em', cursor: 'pointer' }}>
              <Typography variant='body1' sx={{ color: 'var(--blue-500)', textAlign: 'center' }}>upload here.</Typography>
              <input hidden type='file' name='file' accept={props.accept} onChange={handleFileSelect} onClick={clearFile} data-testid='filePickerInput' />
            </Link>
      }
        </Box>
      </Box>
    </Box>
  )
}
